export default "__VITE_ASSET__38771edb__"